import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PlanDataService } from '@oneqrew-partnertool/utils';
import { selectCustomer, selectPlan } from '@oneqrew-partnertool/core';
import { Customer, Plan } from '@oneqrew-partnertool/models';
import * as frontPageTxt from '../../../../../shared-assets/data/pages/front-page.json';
import { ContactCtaComponent } from '@oneqrew-partnertool/contact-cta';
import { ContainerComponent } from '@oneqrew-partnertool/container';
import { NewPlanSelectorComponent } from '@oneqrew-partnertool/new-plan-selector';
import { PromotionBannerComponent } from '@oneqrew-partnertool/promotion-banner';
import { SubscriptionOverviewComponent } from '@oneqrew-partnertool/subscription-overview';
import { SharedModule } from '@oneqrew-partnertool/utils';
import { ModuleAddonsComponent } from '@oneqrew-partnertool/module-addons';

@Component({
  selector: 'lib-new-plan',
  standalone: true,
  imports: [
    SharedModule,
    ContainerComponent,
    PromotionBannerComponent,
    NewPlanSelectorComponent,
    SubscriptionOverviewComponent,
    ContactCtaComponent,
    ModuleAddonsComponent
  ],
  templateUrl: './new-plan.component.html',
  styleUrls: ['./new-plan.component.scss']
})
export class NewPlanComponent implements OnInit {
  class: string = 'new-plan';
  frontPageTxt = frontPageTxt;
  plans: Plan[] = [];
  plan$!: Observable<Plan>;
  customer$!: Observable<Customer>;
  isInitialized = false;

  constructor(private store: Store, private planDataService: PlanDataService) { }

  ngOnInit(): void {
    // Check sessionStorage for 'planSet' flag
    const isPlanSet = sessionStorage.getItem('planSet');
    this.customer$ = this.store.select(selectCustomer).pipe(filter((customer) => !!customer));

    this.plan$ = this.store.select(selectPlan);
    this.isInitialized = true;
  }
}
